<template>

  <div class="atividades-rfilancamentos ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="2">
                <label for="select-rfi-empresa">Empresa</label> 
                <multiselect  id="selecao-empresa-cor"  v-model="valor_empresa"                   
                  :options="empresas" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true" 
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Empresa" label="empresa" track-by="empresa" name="empresa"              >                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="1">
                <label for="select-rfi-filial">Filial</label>  
                <multiselect id="selecao-filial-cor"  v-model="valor_filial"                    
                  :options="filiais" 
                  :multiple="true"   
                  @close="loadLegenda()"                                 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>
<!--
              <b-col cols="2">
                <label for="select-rfi-situacao">Legenda</label> 
                <multiselect  v-model="valor_situacao"  
                  :options="legendas" 
                  :multiple="true"                   
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a legenda" label="legenda" track-by="legenda" name="legenda"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} legenda selecionada</span></template>
                </multiselect> 
              </b-col>
-->


                            <b-col col cols="1">
                   <div>                            
                        <label  for="datepicker-placeholder">Data inicio</label>
                        
                        <b-form-datepicker id="datepicker-placeholder" required  v-model="emissao_inicio" placeholder="Data inicio" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                    </div>                     
              </b-col>

              <b-col cols="1"  class="mb-0">
                <label  for="input-busca">Hora Inicio</label>
                <b-form-input id="buscamonitoramento" v-model="hora_inicio" v-mask="'##:##'"  required="required" placeholder="HH:MM"></b-form-input>              
              </b-col>     

              <b-col col cols="1">
                <div>                            
                    <label  for="datepicker-placeholder">Data Fim</label>
                    <b-form-datepicker id="datepicker-placeholder2" required v-model="emissao_fim" placeholder="Data fim" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

                                         <b-col cols="1"  class="mb-0">
                <label  for="input-busca">Hora Fim</label> 
                <b-form-input id="buscamonitoramento" v-model="hora_fim" v-mask="'##:##'"  required="required" placeholder="HH:MM"></b-form-input>              
              </b-col>     



              <b-col cols="2"  class="mb-0">
                <label  for="input-busca">Pesquisa no grid</label> 
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Digite o nº do carro"></b-form-input>              
              </b-col>      

<!--
              <b-col cols="1"  class="mt-4 ml-2">
                <b-button variant="warning" class="ml-5 mt-2"  block  v-b-modal.modal-multi-1  @input="loadTacografosLancamentos()" >Carregar</b-button>
              </b-col>
-->
                            <b-col cols="1"  class="mt-4 ml-2">
                <b-button variant="warning" class="ml-5 mt-2"  block  @click="loadTacografosLancamentos()" >Carregar</b-button>
              </b-col>

                                      <!-- botão para gerar a planilha -->
              <b-col cols="1"  class="ml-5 mt-4">
                       
                <b-button  variant="success" class="mr-2 mt-2" block  @click="carregando = true,gerarPlanilha()">
                  Gerar planilha
                </b-button>                      
              </b-col>


          </b-row>



     
      <b-row>
        <b-col>
          <b-card-group class="ml-3 mt-3" deck>   


              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="LANÇAMENTOS"
                header-bg-variant="primary  "
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                    {{ tacografos.length }} 

                  </h2>
                </b-card-text>
              </b-card>

              <!--    RESERVA TECNICA           -->
              <!--    RESERVA TECNICA           -->
              <!--    RESERVA TECNICA           -->

            <b-card                  
              
              class="mr-2"              
              style="width: 33rem;"
              border-variant="success"
              header="DIGITAL"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ rfilancamentos.length }} 
                </h2>
              </b-card-text>
            </b-card>

            
            



          <!-- MÉDIA DE DIAS PARADO    -->
          <!-- MÉDIA DE DIAS PARADO    -->
          <!-- MÉDIA DE DIAS PARADO    -->          

            <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="warning"
                header="ANALÓGICO"
                header-bg-variant="warning  "
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                     {{ tacografos.length }}

                  </h2>
                </b-card-text>
              </b-card>

        </b-card-group> 

        </b-col>
        
     </b-row>
    </b-form >


    <!--tbl de dados -->
    <b-table id="rfilanc"  small hover striped sticky-header="762px"  :items="tacografos" :fields="fieldsrfi"  class="mt-4">    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="editTacografo(data.item), loadEmpresasCad(), loadFiliaisCad() , loadLegendaCad(),loadVeiculo()"    title="Acessar RFI"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-1>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA TACÓGRAFO DIGITADOS -->
      <!--  MODAL GRAVAÇÃO RELACAO DA TACÓGRAFO DIGITADOS -->

      <div> 
        
        
        <b-modal id="modal-multi-1" cancel-title="Novo"  ok-title="Gravar" @ok="postNroRfi(), reset()"  hide-footer  size="xl" title="Manutenção de tacógrafos"  no-close-on-esc no-close-on-backdrop>

        <b-row>
           
          <b-col cols="9">
            <div>

            <b-row>
                <b-col cols="6">
                <label for="input-garagem">Empresa</label> -- {{tacografo.empresa_id}}
                <div>                
                  <b-form-select   
                    id="garagem"    
                    
                    v-model="tacografo.empresa_id"                    
                    required                                                   
                    :options="empresascad"
                    @change="loadFiliaisCad()"
                    class="mb-3 "
                    text-field="empresa"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="4">
                <label for="input-garagem">Filial</label>   
                <div>                
                  <b-form-select   
                    id="garagem"    
                    
                    v-model="tacografo.filial_id"                    
                    required      
                    :options="filiaiscad"                    
                    @change="loadLegendaCad()"                                             
                    class="mb-3 "
                    text-field="filial"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="2">
                <label for="input-live">Idº</label>     
                <b-input-group-text >{{ tacografo.id > 0 ? tacografo.id : (nroRfi > 0 ? nroRfi : '-' ) }}</b-input-group-text>
            </b-col> 

            </b-row>

            <b-row>
              <input  id="id-carro" type="hidden" v-model="rfi.carro_id" />

              
              <b-col cols="2">
                <label for="input-live">Carro</label> 
                <b-form-input id="carro" v-model="tacografo.carro" required @click="reset()" @keyup.enter="loadVeiculo(),postNroRfi()" placeholder="Nº do carro"></b-form-input>                                              
              </b-col>

              <b-col cols="4">
                <label class="ml-4" for="input-live">Modelo Chassi</label> 
                <b-input-group-text >{{ veiculos.map(at => at.chassi).length > 0 ? veiculos.map(at => at.chassi).join(', ') : '-' }}</b-input-group-text>
              </b-col>

              <b-col cols="2">
                <label for="input-live">Placa</label>     
                <b-input-group-text >{{ veiculos.map(at => at.chassi).length > 0 ? veiculos.map(at => at.placa).join(', ')  : '-' }}</b-input-group-text>
              </b-col> 




            </b-row>


            <b-row>

            <b-col cols="10">
              <label for="input-setor">Legenda</label>
              <div>                
                <b-form-select                  
                  v-model="tacografo.legenda_id"                    
                  required                                                   
                  :options="legendascad"
                  class="mb-3 "
                  text-field="legenda"                            
                >
                
                </b-form-select>
              </div>
            </b-col>  

              
                <b-col cols="2">                                              
                  <b-form-checkbox
                    id="lavador" 
                    class="mb-3 mt-5"
                    v-model="tacografo.foto"                  
                    name="checkbox-1"
                    value="true"
                    unchecked-value="false"
                    checked="true"                    
                  >                  
                  Foto <!-- --{{rfilancamento.lavador}} -->
                  </b-form-checkbox>                
                </b-col>
              
            </b-row> 

            <b-row>
              <b-col sm="2">
                <label for="textarea-small">Observações</label> 
              </b-col>
              <b-col sm="12">
                <b-form-textarea
                  id="id-pecas" 
                  v-model="tacografo.observacao"                  
                  size="sm"
                  placeholder="Digite códigos dos materias"
                ></b-form-textarea>
              </b-col>
            </b-row> 



              <b-button class="mt-3" variant="success" block @click="postTacografo()">Gravar 2</b-button> 
            
          </div>
          

          </b-col>

           <b-col cols="3">
            <div>
              <img :src="tacografo.foto_thumbnail" alt="-" width="220" height="380">
            </div>
          </b-col>

          </b-row>       



          
        </b-modal>

        <!-- DADOS DO MODAL -->
        




      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->


      
    </div>  


  
  



</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import * as XLSX from 'xlsx'
import VueTheMask from 'vue-the-mask';
import moment from 'moment'
import { mapState } from 'vuex' 


export default {    
    name: 'ManutencaoRfiLancamento',  

    computed : { ... mapState (['user'],),
      itemsFiltered(){
        let valores = [];
       // const values = Object.values(obj);
        valores = this.tacografos.filter((item) =>{
          return (
            item.carro.indexOf(this.search) >-1 
          );
        });
        return valores
        },       

    diaDaSemana() {
      const dataAtual = new Date();
      return dataAtual.getDay(); // Retorna um número de 0 (domingo) a 6 (sábado)
    }

    } ,

    



    data: function() {

        
      
        return {            
            empresas:[],
            filiais:[],
            legendas:[],
            empresascad:[],
            filiaiscad:[],
            legendascad:[],           

            empresa:{},
            tacografos:[],
            tacografo:{},
            statuss:[],
            valor_empresa :[],
            valor_filial:[],
            valor_situacao:[],
            valor_status:[],            

            rfilancamentos:[],            
            rfi:{},
            nroRfi:null,
            veiculos:[],
           
            
            empresasc:[],
            filiaisc:[],
            statussc:[],
            legendasc:[],
            search:'',

            emissao_inicio: '',      
            emissao_fim: '',   
            hora_inicio:'',
            hora_fim:'',
            
            fieldsrfi: [
                { key: 'id', label: 'Nº', sortable: true },     
                { key: 'empresa_id', label: 'Empresa', sortable: true },                 
                { key: 'filial_id', label: 'Filial', sortable: true },                 
                { key: 'dt_cadastro', label: 'Dt digitação', sortable: true, formatter: (value, key, tacografos) => {
                    return moment(tacografos.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },
                { key: 'dt_alteracao', label: 'Dt alteração', sortable: true, formatter: (value, key, tacografos) => {
                    return moment(tacografos.dt_alteracao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },
                
                { key: 'carro', label: 'Carro', sortable: true },      
                { key: 'legenda', label: 'Legenda', sortable: true },
                { key: 'odometro', label: 'Odometro', sortable: true },                
                { key: 'encerrante1', label: 'Catraca 1', sortable: true },    
                { key: 'encerrante2', label: 'Catraca 2', sortable: true },                    
                { key: 'observacao', label: 'Observação', sortable: true },                                                   
                { key: 'foto', label: 'Foto', sortable: true,
                    formatter: value => value ? 'Sim' : 'Não' },
                
                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect,VueTheMask
    },
    methods: {

      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },

        gerarPlanilha() {
        // Objeto com os dados para a planilha
        const dados = this.tacografos

        // Cria uma nova planilha
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dados);

        // Adiciona a planilha ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Salva o workbook como arquivo
        XLSX.writeFile(workbook, 'tacografos_listagem.xlsx');
      },



      ////////////////////////// metodos tacógrafo
      loadEmpresas() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/jb/controle/empresa`
          axios.post(url,corpo).then(res => {
            this.empresas = res.data.map(emp => {              
              return { id_empresa: emp.id_empresa, empresa: emp.empresa }
            })
          })
      },
      
      loadEmpresasCad() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/jb/controle/empresa`
          axios.post(url,corpo).then(res => {
            this.empresascad = res.data.map(emp => {              
              return { ... emp, value: emp.empresa_id, empresa: emp.empresa}
                        
            })
          })
      },  
      
      loadFiliais() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };
          const url = `${baseApiUrl}/jb/controle/empresa/filial`
          axios.post(url,corpo).then(res => {
            this.filiais = res.data.map(filial => {              
              return { id_filial: filial.id_filial, filial: filial.filial }        
            })
          })
      },

      loadFiliaisCad() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };
          const url = `${baseApiUrl}/jb/controle/empresa/filial`
          axios.post(url,corpo).then(res => {
            this.filiaiscad = res.data.map(fil => {              
              return { ... fil, value: fil.filial_id, filial: fil.filial}
            })
          })
      },

      loadLegenda() {
            let corpo = {    
                "empresa_id": `${this.valor_empresa.map(e => e.id_empresa)}`,  
                "origem": 'LISTAGEM'                                          
            };
          const url = `${baseApiUrl}/jb/manutencao/tacografo/legenda/listagem`
          axios.post(url,corpo).then(res => {
            this.legendas = res.data.map(sit => {              
              return { id: sit.id, legenda: sit.legenda }        
            })
          })
      },

      loadLegendaCad() {
            let corpo = {    
                "empresa_id": `${this.valor_empresa.map(e => e.id_empresa)}`,  
                "origem": 'LISTAGEM'                                          
            };
          const url = `${baseApiUrl}/jb/manutencao/tacografo/legenda/listagem`
          axios.post(url,corpo).then(res => {
            this.legendascad = res.data.map(leg => {              
              return { ... leg, value: leg.id, legenda: leg.legenda}
            })
          })
      },

      
      loadTacografosLancamentos() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,         
                "data_inicio": `${this.emissao_inicio}`,         
                "data_fim": `${this.emissao_fim}`,         
                "hora_inicio": `${this.hora_inicio}`,         
                "hora_fim": `${this.hora_fim}`,         
                "origem": 'WEB'                                          
            };
          const url = `${baseApiUrl}/jb/manutencao/tacografo/mov/listagem`
          axios.post(url,corpo).then(res => {
            this.tacografos = res.data
          })
      },

             
      editTacografo(tacografo){
            this.tacografo = { ...tacografo}
      },

              /////////////////////////////////////////////////////////
        postTacografo() { 
            let corpo = {                             
            "id": this.tacografo.id > 0 ?this.tacografo.id  : null,   
            "id_funcionario_erp": `${this.user.id_funcionario_erp}`,
            "empresa_id": `${this.tacografo.empresa_id}`,
         "filial_id": `${this.tacografo.filial_id}`,                        
            "carro_id": `${this.tacografo.carro_id}`,
            "legenda_id": `${this.tacografo.legenda_id}`,            
            "observacao": `${[this.tacografo.observacao]}`,         
            "foto": `${[this.tacografo.foto]}`            
            
            
            }; 
          const url = `${baseApiUrl}/jb/manutencao/tacografo/mov`
          axios.post(url,corpo).then(() => {
              this.$toasted.global.defaultSuccess()                
              this.limparCorpo()               
              this.loadTacografosLancamentos()            

           })
           .catch(showError)
        },

        limparCorpo(){
        this.tacografo =[]        
        this.empresascad=[]
        this.filiaiscad=[]
        this.legendascad=[]
        this.veiculos=[]       
      },

      loadVeiculo() {
          let corpo = {    
              "empresa_id": `${this.tacografo.empresa_id}`,
              "carro": `${this.tacografo.carro}`                 
          };
          const url = `${baseApiUrl}/jb/manutencao/frota/listagem`
          axios.post(url,corpo)                      
          .then(res => { this.veiculos = res.data })                      
          .catch(showError)
        },





       
    },



    mounted() {        
      this.loadEmpresas()  
      this.loadTacografosLancamentos()
      this.loadLegenda()

      
    },



}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>





</style>